import React, { useState } from 'react'
import { Row, Col, Badge, Card } from 'react-bootstrap'
import { useBusinessRule } from 'api/hooks/use-business-rules'
import { useBusinessRulePendingWorkflows } from 'api/hooks/use-business-rule-pending-workflows'
import PendingWorkflowTable from './PendingWorkflowTable'
import FlowchartTab from './FlowchartTab'
import { split } from 'lodash'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import Tabs from 'duties/shared/tabs'
import { AssignedBadge, DollarAmountBadge } from 'shared/badges'

function BusinessRules() {
  const queryString = window.location.pathname
  const id = split(queryString, '/')[2]
  const params = { id: id }
  const { data: rule, isSuccess } = useBusinessRule({ params })

  const [activeTab, setActiveTab] = useState('flowchart')

  const [workflowParams, setWorkflowParams] = useState({
    business_rule_id: id,
    page: 1,
    perPage: 25
  })

  const {
    data: workflows,
    isSuccess: workflowsSuccess,
    isLoading: workflowsLoading
  } = useBusinessRulePendingWorkflows({ params: workflowParams })

  const crumbs = [
    { name: 'Workflow Processes', url: 'processes' },
    { name: rule?.process_name, url: rule?.workflow_process_type_id ? `processes/${rule.workflow_process_type_id}` : '' },
    { name: rule?.external_id ? `Rule #${rule.external_id}` : '', url: '' }
  ]

  return (
    <Page title={'Access Management'}>
      <PageTitle breadcrumbs={crumbs} />
      <Row>
        <Col>
          <h1>Business Rule Details</h1>
          {isSuccess && (
            <Card className="mb-4">
              <Card.Body>
                <Row>
                  <Col sm={3}>
                    <div className="fw-bold">Process (ID)</div>
                    <div className="fw-light mt-2">
                      {rule.process_name}
                      {' ('}
                      {rule.external_id}
                      {')'}
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="fw-bold">Assigned To</div>
                    <div className="fw-light mt-2">
                      <AssignedBadge rule={rule} />
                    </div>
                  </Col>
                  <Col sm={2}>
                    <div className="fw-bold">Step Number</div>
                    <div className="fw-light mt-2">{rule.step_number}</div>
                  </Col>
                  <Col sm={2}>
                    <div className="fw-bold">Rule Type</div>
                    <div className="fw-light mt-2">{rule.rule_type}</div>
                  </Col>
                  <Col sm={2}>
                    <div className="fw-bold">Approval Type</div>
                    <div className="fw-light mt-2">{rule.approval_type}</div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={3}>
                    <DollarAmountBadge rule={rule} />
                    <Badge className="text-center ms-2 bg-light text-primary fw-normal">
                      Dept: {rule.department}
                    </Badge>
                    {rule.location && (
                      <Badge className="text-center ms-2 bg-light text-primary fw-normal">
                        Loc: {rule.location}
                      </Badge>
                    )}
                    {rule.is_all_approvals && (
                      <Badge className="text-center ms-2 bg-light text-primary fw-normal">
                        All Approvals
                      </Badge>
                    )}
                    {rule.is_catch_all && (
                      <Badge className="text-center ms-2 bg-light text-primary fw-normal">
                        Catch All
                      </Badge>
                    )}
                    {rule.is_bypass_restart && (
                      <Badge className="text-center ms-2 bg-light text-primary fw-normal">
                        Bypass Restart
                      </Badge>
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}

          <div className="d-flex mb-2">
            <Tabs
              tabs={[
                { name: 'Flowchart', value: 'flowchart' },
                { name: 'Pending Workflows', value: 'pending' }
              ]}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>

          {activeTab === 'pending' && (
            <PendingWorkflowTable
              isLoading={workflowsLoading}
              isSuccess={workflowsSuccess}
              data={workflows}
              params={workflowParams}
              setParams={setWorkflowParams}
            />
          )}

          {activeTab === 'flowchart' && isSuccess && <FlowchartTab rule={rule} />}
        </Col>
      </Row>
    </Page>
  )
}

export default BusinessRules
